<ng-container [ngSwitch]="state">
    <ui-button
        *ngSwitchCase="CampaignActionState.List"
        id="interaction-topbar-open-campaigns"
        type="default"
        [text]="'VIEW CAMPAIGNS ' + '(' + campaigns.length + ')'"
        [uiDropdownTarget]="campaignsDropdown.dropdown"
        (dropdownOpened)="onDropdownOpenToggle(true)"
        (dropdownClosed)="onDropdownOpenToggle(false)"
        [loading]="(isUpdatingChecksums$ | async)!"
        svgIcon="campaigns-l">
    </ui-button>

    <ui-button
        id="push-changes-button"
        class="push-button"
        type="primary"
        text="PUSH CHANGES"
        [loading]="isPublishing"
        *ngSwitchCase="CampaignActionState.Push"
        [loading]="(isUpdatingChecksums$ | async)!"
        svgIcon="campaigns-l"
        (click)="onPublishCreatives()">
    </ui-button>

    <ui-button
        id="create-campaign-button"
        *ngSwitchCase="CampaignActionState.Create"
        (click)="onCreateCampaign()"
        (dropdownOpened)="onDropdownOpenToggle(true)"
        (dropdownClosed)="onDropdownOpenToggle(false)"
        [uiDropdownTarget]="hasSocialCampaignPermissions ? campaignsDropdown.dropdown : empty"
        type="primary"
        text="CREATE CAMPAIGN"
        svgIcon="campaigns-l"
        uiTooltip="Create new campaign to publish your creatives"
        uiTooltipPosition="bottom"
        [uiTooltipWidth]="265">
    </ui-button>

    <campaigns-dropdown
        #campaignsDropdown
        [hasConnectedCampaigns]="hasConnectedCampaigns"
        [isAddToCampaignVisible]="state === CampaignActionState.List">
    </campaigns-dropdown>
    <ui-dropdown #empty></ui-dropdown>

    <add-to-campaign-dropdown
        #addToCampaignDropdown
        (disabled)="addToCampaignDisabled = $event"
        (title)="addToCampaignText = $event"></add-to-campaign-dropdown>
</ng-container>
